import styles from "./Header.module.scss";
import { Divider, Nav, ImageContainer } from "../../components";

export const Header = () => {
	return (
		<div className={styles.header}>
			<ImageContainer className={styles.heroImage}>
				<img alt="massage" src="/hero.jpg" />
			</ImageContainer>
			<Nav />
			<h1>
				SPORTMASSAGE <br /> HETTY
			</h1>			
			<Divider orientation="bottom" />
		</div>
	);
};
